import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  inputBackGroundColor: {
    backgroundColor: palette.background.default,
    '& > div': {
      paddingLeft: 12,
      paddingRight: 4,
    },
  },
  adjustedWidth: {
    width: 'fit-content',
  },
  withMarginBottom: {
    marginBottom: 20,
  },
}));
